import React from 'react';
import styles from './availabilityIcon.module.scss';

export default function AvailabilityIcon({ level }) {
    const numberOfBars = 5;

    const bars = [];

    if (level === undefined || level > numberOfBars) {
        level = 5;
    }

    for (let i = 1; i <= numberOfBars; i++) {
        if (i <= level) {
            bars.push(
                <div key={i} data-testid={'activeBar'} className={styles.active}>
                    {' '}
                </div>
            );
        } else {
            bars.push(<div key={i}> </div>);
        }
    }

    return (
        <>
            <div role={'img'} className={`${styles.container}`}>
                {bars}
            </div>
        </>
    );
}
